/**
 * Nomes das categorias/subcategorias de "balde" plantadas pelo seed — nos DOIS idiomas.
 *
 * O banco guarda o nome JÁ TRADUZIDO do idioma em que foi semeado (ver `seed_locale` em
 * db/seed.ts) e as categorias não têm chave estável: `categories.id` é gerado, e o único
 * identificador é o `name`. Então quem precisa reencontrar essas linhas casa por nome —
 * e tem que casar nos dois seeds:
 *
 *   assets/seed/categories.json     → categoria "Outros", subcategorias [..., "Ajustes", "Outros"]
 *   assets/seed/categories.en.json  → categoria "Other",  subcategorias [..., "Adjustments", "Other"]
 *
 * Casar só em português fazia o install em INGLÊS não achar nada e cair no `null`: os
 * lançamentos automáticos de fatura (crédito da fatura anterior, saldo anterior, ajuste)
 * nasciam SEM categoria — visível como o selo "1 uncategorized" no extrato. Pior, o
 * fallback de exclusão de categoria despejava os lançamentos na PRIMEIRA categoria do
 * mesmo tipo (ex.: "Housing") em vez do balde.
 *
 * O usuário pode renomear a categoria; nesse caso nada casa e quem chama degrada para
 * `null` (comportamento já existente) — o objetivo aqui é acertar o seed intocado.
 */

/** 'Others' fica na lista por segurança: era o nome que o fallback antigo procurava. */
const CATCH_ALL_NAMES = ['outros', 'other', 'others'];

const ADJUSTMENTS_NAMES = ['ajustes', 'adjustments'];

function normalize(name: string | null | undefined): string {
    return (name ?? '').trim().toLocaleLowerCase();
}

/** Categoria/subcategoria "balde" do seed ("Outros" em pt-BR, "Other" em en). */
export function isSeedCatchAllName(name: string | null | undefined): boolean {
    return CATCH_ALL_NAMES.includes(normalize(name));
}

/** Subcategoria de ajustes do seed ("Ajustes" em pt-BR, "Adjustments" em en). */
export function isSeedAdjustmentsName(name: string | null | undefined): boolean {
    return ADJUSTMENTS_NAMES.includes(normalize(name));
}
